$(function () {
    //$('.meet-the-team__thumbnail').click(function () {
    $('.meet-the-team__panel').click(function () {
        //var parent = $(this).parent();
        openPanel($(this));
    })
}); 

function openPanel(parent) {

    description_height = $(parent).find('.meet-the-team__description').outerHeight();

    $('.meet-the-team__panel').not(parent).removeClass('meet-the-team__panel--active');

    setTimeout(function () {
        $('.meet-the-team__panel').css('padding-bottom', '');
        $(parent).css('padding-bottom', description_height + 30);
        $(parent).toggleClass('meet-the-team__panel--active');

    }, 300);

}
